module.exports = __webpack_public_path__ + "static/media/OS.7a590a5d.png";